module.exports = __webpack_public_path__ + "img/info-white.9da98b8b.svg";